import { ERR_RAS_MIN, ERR_RAS_MAX } from '../../../core/js/enums/localizationEnums';

/**
 * Concat a bunch of values into a comma separated string for the email
 * @param {String} styleNumber the product's style number
 * @param {String} displayName the product's display name
 * @param {Object} swatch a swatch object
 * @returns {String} comma separated swatch values
 */
export const buildSwatchString = (styleNumber, displayName, swatch) =>
    `${styleNumber},${swatch.colorCode},${displayName},${swatch.displayName}`;

export function getRASMinimumMessage() {
    return {
        slug: ERR_RAS_MIN
    };
}

export function getRASMaximumMessage() {
    return {
        slug: ERR_RAS_MAX
    };
}
